module.exports = __webpack_public_path__ + "05beeaa12dc7b01dd23886fd2ecb934e.pdf";